export default "__VITE_ASSET__2dd5a730__"